import { Link, Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { RouterContext } from '@/router-context';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  notFoundComponent: NotFound,
});

function NotFound() {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-background p-6 text-center">
      <h1 className="text-h1">Page not found</h1>
      <p className="text-body text-muted-foreground">
        The page you are looking for does not exist.
      </p>
      <Link to="/" className="text-body text-primary underline-offset-4 hover:underline">
        Go to the dashboard
      </Link>
    </main>
  );
}
